import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';

var Config = require('../../../config');

class UnitDelivered extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);

		this.state = {
			unit:"",

		}
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}


	render(){
		const {t} = this.props;
		var session = sessionStorage.getItem('health_facilities_name');

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.patients.MAIN')} ->
						Unidades enviadas
					</h5>
				</div>

				<div className="col-xs-12">
					<div className="col-xs-12 col-sm-2">
						<span>No. Unidad</span>
						<input type="text" name="unit" id="id" value={this.state.unit} onChange={this.handleChange}
							className="form-control" />
					</div>
					<div className="col-xs-12 col-sm-1">
						<button className="btn btn-info" style={{marginTop:'18px'}}>Buscar</button>
					</div>
				</div>
			</div>
		)
	}
} 

export default translate('translations')(UnitDelivered);